import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import DataTable from "../../component/DataTable";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AddLocation from "./AddLocation";
import EditLocation from "./EditLocation";

const listEndpoint = ApiEndpoints.loc.List;
const deleteEndpoint = ApiEndpoints.loc.Delete;
const tableHeader = ["Date","Name"];
const tbody = ["createdAt","name"];

const dataFetch = async (setData) => {
  try {
    const response = await ApiRequest("GET", listEndpoint);
    const result = response.locations;
    setData(result);
  } catch (error) {
    console.log(error);
  }
};

export default function Location() {

  const [data, setData] = useState([]);
  const [locId, setLocId] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modaleditShow, setModalEditShow] = useState(false);

  useEffect(() => {
    dataFetch(setData);
  }, []);

  // const handleDelete = async (location_id) => {
  //   const payload = { location_id };
  //   try {
  //     const response = await ApiRequest("POST", deleteEndpoint, payload);
  //     toast.success(response.message);
  //     dataFetch();
  //   } catch (error) {
  //     console.error("Error deleting author:", error);
  //   }
  // };

  const pagename = {
    name: 'Job Management',
    user: 'Admin',
    innerpage: 'Job Management / location'
  }

  return (
    <>
    <AdminHeader pagename={pagename}/>
  
    <div className="add-btn-section">
      <Link className="admin-add-btn" onClick={() => setModalShow(true)}>Add +</Link>
      <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        setModalShow={setModalEditShow}
        setId = {setLocId}
        // onDelete={handleDelete}
      />
    </div>

    <AddLocation show={modalShow} onHide={() => setModalShow(false)}/>
    <EditLocation show={modaleditShow} locId ={locId} onHide={() => setModalEditShow(false)}/>
    </>
  )
}
